<template>
  <div class="dots-loader">
    <span
      class="dot"
      :class="{ small }"
      v-for="n in 3"
      :key="n"
      :style="{ animationDelay: `${(n - 1) * 0.2}s` }"
    />
  </div>
</template>

<script lang="ts">
import { defineComponent } from "vue"

export default defineComponent({
  name: "DotsLoader",
  props: {
    small: {
      type: Boolean,
      default: false,
    },
  },
})
</script>

<style scoped lang="scss">
.dots-loader {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
}

.dot {
  width: 20px;
  height: 20px;
  border-radius: 50%;
  background: var(--text-gradient-165);
  animation: blink 1.4s infinite ease-in-out both;

  &.small {
    width: 12px;
    height: 12px;
  }
}

@keyframes blink {
  0%,
  80%,
  100% {
    transform: scale(0.6);
    opacity: 0.3;
  }
  40% {
    transform: scale(1);
    opacity: 1;
  }
}
</style>
